import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section id="category-nav" className="w-full py-14 md:py-20 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm mt-2">探索你感兴趣的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-foreground-900 font-semibold text-sm group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-foreground-400 text-xs mt-0.5">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}